import axios from "axios";
import authStore from "./_stores/auth.store";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const httpClient = axios.create({
  //baseURL: "http://localhost:8000/api", // local
  //baseURL: "http://10.160.15.133:8000/api", // client azure
  //baseURL: "http://4.193.32.113:8000/api", // peracto azure
  //baseURL: "http://20.204.17.11:8000/api", // peracto azure
  //baseURL: "http://43.204.127.104:8000/api", // peracto Prod
  //baseURL: "http://162.44.205.22:3000/api", // client Internal
  //baseURL: "https://162.44.202.76:3000/api", // client External
  //baseURL: "https://uat-dst.iqvia.com:3003/api", // client UAT External
  //baseURL: "https://uat-dst.iqvia.com:3005/api", // client UAT External
  //baseURL: "https://dst.iqvia.com:3000/api", // client PROD External
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

httpClient.interceptors.request.use(
  function (config) {
    // Ensure headers object exists
    if (!config.headers) {
      config.headers = {};
    }

    // Get auth token from store (compatible with older Babel)
    const state = authStore.getState();
    const authToken = state && state.auth_reducer && state.auth_reducer.authToken;

    // Set token if it exists
    if (authToken) {
      config.headers["x-auth-token"] = authToken;
    }

    return config;
  },
  function (error) {
    console.error("axios.interceptors.request error => ", error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors (token expiration)
httpClient.interceptors.response.use(
  function (response) {
    // Pass through successful responses
    return response;
  },
  function (error) {
    // Handle 401 Unauthorized errors (expired or invalid token)
    if (error.response && error.response.status === 401) {
      // Import auth store actions
      const authStoreModule = require("./_stores/auth.store");
      const types = authStoreModule.types;
      const actions = authStoreModule.actions;

      // Clear auth storage and reset state
      actions.removeAuthStorage();
      authStore.dispatch({ type: types.INIT_AUTH_STATE });

      // Redirect to login page
      const subdomain = process.env.REACT_APP_SUB_DOMAIN || '';
      window.location.href = subdomain + '/login';
    }

    return Promise.reject(error);
  }
);

export default httpClient;
